export default __webpack_public_path__ + "static/unknownurl-1d98c6f23989387ce505ad264aec3b26.png";